import { useEffect, useState } from "react";
import client from "../lib/api";
import { DISQUALIFY_REASONS } from "../components/DealControls";

// Disqualify reasons ordered by this workspace's habits (most-used first).
export function useReasonOrder() {
  const [state, setState] = useState({ reasons: DISQUALIFY_REASONS, frequent: [] });
  useEffect(() => {
    let alive = true;
    client.get("/insights/disqualify-reasons").then((r) => { if (alive) setState({ reasons: r.data.reasons, frequent: r.data.frequent || [] }); }).catch(() => {});
    return () => { alive = false; };
  }, []);
  return state;
}
